import URL from '@/tools/url';
import jquery from 'jquery';

/**
 * @memberof module:ajaxAPI/cart
 * @alias get
 *
 * @description Получение состава корзины
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.cart.get()
 *  .done(function (onDone) { console.log('onDone:', onDone) })
 *  .fail(function (onFail) { console.log('onFail:', onFail) });
 */

export default function () {
  var _lang = URL.getKeyValue('lang') || '';
  var fields = { lang: _lang };

  return jquery.getJSON('/front_api/cart.json', fields);
};
